"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSection = void 0;
const formSection_1 = require("./formSection");
const workflowActionSection_1 = require("./workflowActionSection");
const commentSection_1 = require("./commentSection");
const fullWorkflowSection_1 = require("./fullWorkflowSection");
const endSection_1 = require("./endSection");
const patientNotesSection_1 = require("./patientNotesSection");
const patientInfoSection_1 = require("./patientInfoSection");
const indicatorSection_1 = require("./indicatorSection");
function buildSection(section, schemas, language) {
    const sectionType = section.type;
    if (sectionType === 'info') {
        return [(0, patientInfoSection_1.buildInfoSection)(section)];
    }
    else if (sectionType === 'notes') {
        return [(0, patientNotesSection_1.buildNotesSection)(section)];
    }
    else if (sectionType === 'end') {
        return [(0, endSection_1.buildEndSection)(section)];
    }
    else if (sectionType === 'workflow') {
        if (!schemas)
            throw new Error(`Schemas must be provided to create a full workflow section schema`);
        const workflowSchema = schemas[section.workflow.toString()];
        return (0, fullWorkflowSection_1.buildFullWorkflowExportSections)(section, workflowSchema, schemas);
    }
    else if (sectionType === 'action') {
        if (!schemas)
            throw new Error(`Schemas must be provided to create a workflow action section schema`);
        const workflowSchema = schemas[section.workflow.toString()];
        const sectionSchema = (0, workflowActionSection_1.buildWorkflowActionSection)(section, workflowSchema);
        if (sectionSchema)
            return [sectionSchema];
        return null;
    }
    else if (sectionType === 'form') {
        if (!schemas)
            throw new Error(`Schemas must be provided to create a form section schema`);
        const formSchema = schemas[section.form.toString()];
        const sectionSchema = (0, formSection_1.buildFormSection)(section, formSchema);
        if (sectionSchema)
            return [sectionSchema];
        return null;
    }
    else if (sectionType === 'indicator') {
        if (section.custom != null && section.custom === true) {
            if (!schemas)
                throw new Error(`Schemas must be provided to export a custom indicator section`);
            const indicatorSchema = schemas[section.indicator.toString()];
            const sectionSchema = (0, indicatorSection_1.buildCustomIndicatorSection)(section, indicatorSchema, language);
            if (sectionSchema)
                return [sectionSchema];
            return null;
        }
        else {
            return [(0, indicatorSection_1.buildDefaultIndicatorSection)(section)];
        }
    }
    else if (sectionType === 'comment') {
        return [(0, commentSection_1.buildCommentSection)(section)];
    }
    else if (sectionType === 'ongoing') {
        throw new Error(`Ongoing sections are not fully implemented yet`);
    }
    throw new Error(`Invalid Section.`);
}
exports.buildSection = buildSection;
//# sourceMappingURL=index.js.map